// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__29Lns","left":"InfoRow_left__3zfM5"};